import { rootEventBus, EnumRootEventBus } from "../../../../../../../src/managers/RootEventBus";
import { eventBus, EnumEventBus } from "../../EventBus";
import { DrawingTool } from "../../../types/Enum";
import { Coord } from "../../../../../../../src/types/Interface";

export default class BaseListener {

  constructor() {
    rootEventBus.on(EnumRootEventBus.setPointerDown, (coord: Coord) => this.onPointerDown(coord));
    rootEventBus.on(EnumRootEventBus.setPointerMove, (coord: Coord) => this.onPointerMove(coord));
    rootEventBus.on(EnumRootEventBus.setPointerUp, () => this.onPointerUp());
    eventBus.on(EnumEventBus.setSelectedTool, (tool: DrawingTool, color: number) => this.setSelectedTool(tool, color));
  }

  protected setSelectedTool(tool: DrawingTool, color: number): void { };
  protected onPointerDown(coord: Coord): void { };
  protected onPointerMove(coord: Coord): void { };
  protected onPointerUp(): void { };
}
